import type { CommonPlugin } from "zudoku";

const TRACKER_SRC = "https://api.mindbox.ru/scripts/v1/tracker.js";

export const mindboxTrackerPlugin = (): CommonPlugin => {
  return {
    initialize: () => {
      if (typeof window === "undefined") {
        return;
      }

      const tracker = document.createElement("script");
      tracker.src = TRACKER_SRC;
      tracker.async = true;

      // Очередь заводится синхронно, до приезда асинхронного бандла: вызовы
      // mindbox(...) до его загрузки копятся в ней, а не теряются.
      const init = document.createElement("script");
      init.innerHTML = `
        mindbox = window.mindbox || function() { mindbox.queue.push(arguments); };
        mindbox.queue = mindbox.queue || [];
        mindbox('create');
      `;

      document.head.append(tracker, init);
    },
  };
};
